import axios from 'axios';
import * as Sentry from "@sentry/react";

export const fetchTranslation = async ({ provider, sourceLang, sourceText, settings, languagePair }) => {
    const requestData = {
        provider,
        sourceLang,
        sourceText,
        settings
    };

    const apiUrl = `${process.env.REACT_APP_API_URL}/api/translate/${languagePair}`;
    // const apiUrl = `http://localhost:8080/api/translate/${languagePair}`; // 테스트용

    try {
        const response = await axios.post(apiUrl, requestData, {
            headers: {
                'X-API-KEY': process.env.REACT_APP_API_KEY
            }
        });

        const result = response.data;

        if (result.isSuccess !== true) {
            throw result;
        }

        if (result.data && result.data.translatedText) {
            return result.data.translatedText;
        } else {
            throw new Error("번역 결과를 받아오지 못했습니다.");
        }

    } catch (err) {
        console.error("번역 요청 중 오류 발생:", err);
        Sentry.captureException(err);


        if (err.response) {
            throw err.response.data;
        }

        if (err.request) {
            throw new Error("서버로부터 응답을 받을 수 없습니다. 네트워크 연결을 확인해주세요.");
        } else {
            throw new Error(err.message || "요청을 보내는 중 오류가 발생했습니다.");
        }
    }
};
